import ProductService from '@/api/products/productsService.js';
/* eslint-disable */

export const marketing = {
  namespaced: true,
  state: () => ({
    loading: false,
    retailers: null,
    markets: null,
    incompleteMarketingList: [],
    transactionId: null
  }),

  getters: {
    getRetailers(state) {
      return state.retailers;
    },

    getMarkets(state) {
      return state.markets;
    },

    getIncompleteMarketingList(state) {
      return state.incompleteMarketingList;
    },

    getMarketingTask: (state) => (id) => {
      const order = state.incompleteOrdersList.find((e) => e.transactionId == id);
      return order;
    },

    getProductInformation: (state) => (transactionId) => {
      const product = state.incompleteMarketingList.find((info) => info.transactionId == transactionId);
      if (!product) {
        return {};
      }

      return product.productInformation;
    },

    getUSP: (state) => (transactionId) => {
      const stateInfo = state.incompleteMarketingList.find((info) => info.transactionId == transactionId);
      if (!stateInfo) {
        return [{ info: null }];
      }
      return stateInfo.uniqueSellingPoints && stateInfo.uniqueSellingPoints.length
        ? stateInfo.uniqueSellingPoints[0].content.map((uspText) => {
            return { info: uspText };
          })
        : [{ info: null }];
    },

    getDescription: (state) => (transactionId) => {
      const stateInfo = state.incompleteMarketingList.find((info) => info.transactionId == transactionId);
      if (!stateInfo) {
        return '';
      }
      return stateInfo.description && stateInfo.description.length ? stateInfo.description[0].content : '';
    },

    getKeywords: (state) => (transactionId) => {
      const stateInfo = state.incompleteMarketingList.find((info) => info.transactionId == transactionId);
      if (!stateInfo) {
        return [];
      }
      return stateInfo.keywords && stateInfo.keywords.length ? stateInfo.keywords[0].content.split(',') : [];
    }
  },

  mutations: {
    SET_RETAILERS(state, payload) {
      if (!payload) {
        return;
      }
      state.retailers = JSON.parse(JSON.stringify(payload));
    },

    SET_MARKETS(state, payload) {
      if (!payload) {
        return;
      }
      state.markets = JSON.parse(JSON.stringify(payload));
    },

    SET_MARKETING_LIST(state, payload) {
      state.incompleteMarketingList = JSON.parse(JSON.stringify(payload));
    },

    SET_TRANSACTION_ID(state, payload) {
      state.transactionId = payload;
    }
  },

  actions: {
    async getRetailers({ state, commit }) {
      state.loading = true;
      try {
        const res = await ProductService.getRetailers();
        commit('SET_RETAILERS', res.data);
      } catch (error) {
        console.log('GET RETAILER', error);
      } finally {
        state.loading = false;
      }
    },

    async getMarkets({ state, commit }) {
      state.loading = true;
      try {
        const res = await ProductService.getMarkets();
        commit('SET_MARKETS', res.data);
      } catch (error) {
        console.log('GET MARKETS', error);
      } finally {
        state.loading = false;
      }
    },

    async setIncompleteMarketingList({ commit, state }, list) {
      state.loading = true;

      try {
        const res = await ProductService.getIncompleteMarketing();
        commit('SET_MARKETING_LIST', [...res]);
      } catch (error) {
        console.log('GET INCOMPLETE', error);
      } finally {
        state.loading = false;
      }
    },

    setTaskId({ commit, state }, id) {
      commit('SET_TRANSACTION_ID', id);
    }
  }
};
